/** Brand casts the root `ids.ts` does not export yet.
 *
 * Kept in one place so that when the owner of `ids.ts` adds them the import
 * here becomes a re-export and nothing else in the subsystem moves.
 */

import type {
  BuildingDefId, HeroDefId, InteractionId, SkillDefId, SubskillDefId,
} from "../ids.js";

export {
  asArmyId, asArtifactDefId, asCaravanId, asCreatureDefId, asFactionId, asHeroId,
  asModifierSrcId, asObjectId, asPlayerId, asSpellDefId, asTownId,
} from "../ids.js";

export const asSkillDefId = (s: string): SkillDefId => s as SkillDefId;
export const asSubskillDefId = (s: string): SubskillDefId => s as SubskillDefId;
export const asBuildingDefId = (s: string): BuildingDefId => s as BuildingDefId;
export const asHeroDefId = (s: string): HeroDefId => s as HeroDefId;
export const asInteractionId = (s: string): InteractionId => s as InteractionId;
